export type StringSet = Set<string>;

export const toggleInSet = (
  value: string,
  set: StringSet,
  setState: (s: StringSet) => void,
): void => {
  const next = new Set(set);

  if (next.has(value)) {
    next.delete(value);
  } else {
    next.add(value);
  }
  setState(next);
};

export const toggleAll = (
  values: string[],
  set: StringSet,
  setState: (s: StringSet) => void,
): void => {
  if (set.size === values.length) {
    setState(new Set());
  } else {
    setState(new Set(values));
  }
};
